/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
import { Method, prepare, QueryStringArrayFormat, RequestBodyType, ResponseBodyType } from 'yapi-to-typescript';
// @ts-ignore
// prettier-ignore
import type { RequestConfig, RequestFunctionRestArgs } from 'yapi-to-typescript';
// @ts-ignore
import request from "./request";
// @ts-ignore
import makeRequestHook from "./makeRequestHook";

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>;

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult,
> = (TRequestConfig["requestDataOptional"] extends true
  ? (
      requestData?: TRequestData,
      ...args: RequestFunctionRestArgs<typeof request>
    ) => TRequestResult
  : (
      requestData: TRequestData,
      ...args: RequestFunctionRestArgs<typeof request>
    ) => TRequestResult) & {
  requestConfig: TRequestConfig;
};

const mockUrl_0_0_0_0 = "http://yapi.yishou.com/mock/187" as any;
const devUrl_0_0_0_0 = "" as any;
const prodUrl_0_0_0_0 = "" as any;
const dataKey_0_0_0_0 = "data" as any;

export interface BaobanPcGetOptionInfoRequest {
  /**
   * 选择的co_ids
   */
  co_ids?: string[];
  /**
   * 选择的si_id
   */
  si_ids?: string[];
  /**
   * 尺码搜索
   */
  search_size?: string;
  /**
   * 颜色搜索
   */
  search_color?: string;
  /**
   * goods_no
   */
  goods_no?: string;
}

export interface BaobanPcGetOptionInfoResponse {
  /**
   * 商品尺码信息数据
   */
  size_chart_list?: {
    /**
     * id
     */
    id: string;
    /**
     * 名字
     */
    title: string;
    /**
     * 列名字
     */
    content: string[];
    /**
     * 尺码
     */
    unit: string;
    /**
     * 列名字
     */
    list: {
      chart_name: string;
      chart_list: string[];
      unit: string;
    }[];
  }[];
  /**
   * 颜色列表
   */
  color_list?: {
    id: string;
    label: string;
  }[];
  /**
   * 尺码列表
   */
  size_list?: {
    id: string;
    label: string;
  }[];
  /**
   * 搜索是否有数据 1是 0否
   */
  search_color_result?: string;
  /**
   * 搜索是否有数据 1是 0否
   */
  search_size_result?: string;
}

type BaobanPcGetOptionInfoRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodsLibPc/baobanPcGetOptionInfo",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcGetOptionInfoRequestConfig: BaobanPcGetOptionInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodsLibPc/baobanPcGetOptionInfo",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: {
        co_ids: {
          type: "array",
          items: { type: "string" },
          description: "选择的co_ids",
        },
        si_ids: {
          type: "array",
          items: { type: "string" },
          description: "选择的si_id",
        },
        search_size: { type: "string", description: "尺码搜索" },
        search_color: { type: "string", description: "颜色搜索" },
        goods_no: { type: "string", description: "goods_no" },
      },
    },
    responseDataJsonSchema: {
      type: "object",
      properties: {
        size_chart_list: {
          type: "array",
          items: {
            type: "object",
            properties: {
              id: { type: "string", description: "id" },
              title: { type: "string", description: "名字" },
              content: {
                type: "array",
                items: { type: "string" },
                description: "列名字",
              },
              unit: { type: "string", description: "尺码" },
              list: {
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    chart_name: { type: "string" },
                    chart_list: { type: "array", items: { type: "string" } },
                    unit: { type: "string" },
                  },
                  required: ["chart_name", "chart_list", "unit"],
                },
                description: "列名字",
              },
            },
            required: ["id", "title", "content", "unit", "list"],
          },
          description: "商品尺码信息数据",
        },
        color_list: {
          type: "array",
          items: {
            type: "object",
            properties: { id: { type: "string" }, label: { type: "string" } },
            required: ["id", "label"],
          },
          description: "颜色列表",
        },
        size_list: {
          type: "array",
          items: {
            type: "object",
            properties: { id: { type: "string" }, label: { type: "string" } },
            required: ["id", "label"],
          },
          description: "尺码列表",
        },
        search_color_result: {
          type: "string",
          description: "搜索是否有数据 1是 0否 ",
        },
        search_size_result: {
          type: "string",
          description: "搜索是否有数据 1是 0否 ",
        },
      },
    },
    requestFunctionName: "baobanPcGetOptionInfo",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcGetOptionInfo = /*#__PURE__*/ (
  requestData: BaobanPcGetOptionInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcGetOptionInfoResponse>(
    prepare(baobanPcGetOptionInfoRequestConfig, requestData),
    ...args,
  );
};

baobanPcGetOptionInfo.requestConfig = baobanPcGetOptionInfoRequestConfig;

export const useBaobanPcGetOptionInfo = /*#__PURE__*/ makeRequestHook<
  BaobanPcGetOptionInfoRequest,
  BaobanPcGetOptionInfoRequestConfig,
  ReturnType<typeof baobanPcGetOptionInfo>
>(baobanPcGetOptionInfo);

export interface BaobanPcAddColorRequest {
  /**
   * 颜色
   */
  co_val: string;
}

export interface BaobanPcAddColorResponse {
  /**
   * id
   */
  id: string;
}

type BaobanPcAddColorRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodsLibPc/baobanPcAddColor",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcAddColorRequestConfig: BaobanPcAddColorRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodsLibPc/baobanPcAddColor",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: { co_val: { type: "string", description: "颜色" } },
      required: ["co_val"],
    },
    responseDataJsonSchema: {
      type: "object",
      properties: { id: { type: "string", description: "id" } },
      required: ["id"],
    },
    requestFunctionName: "baobanPcAddColor",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcAddColor = /*#__PURE__*/ (
  requestData: BaobanPcAddColorRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcAddColorResponse>(
    prepare(baobanPcAddColorRequestConfig, requestData),
    ...args,
  );
};

baobanPcAddColor.requestConfig = baobanPcAddColorRequestConfig;

export const useBaobanPcAddColor = /*#__PURE__*/ makeRequestHook<
  BaobanPcAddColorRequest,
  BaobanPcAddColorRequestConfig,
  ReturnType<typeof baobanPcAddColor>
>(baobanPcAddColor);

export interface BaobanPcAddSizeRequest {
  /**
   * 尺码信息
   */
  si_val: string;
}

export interface BaobanPcAddSizeResponse {
  /**
   * id
   */
  id: string;
}

type BaobanPcAddSizeRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodsLibPc/baobanPcAddSize",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcAddSizeRequestConfig: BaobanPcAddSizeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodsLibPc/baobanPcAddSize",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: { si_val: { type: "string", description: "尺码信息" } },
      required: ["si_val"],
    },
    responseDataJsonSchema: {
      type: "object",
      properties: { id: { type: "string", description: "id" } },
      required: ["id"],
    },
    requestFunctionName: "baobanPcAddSize",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcAddSize = /*#__PURE__*/ (
  requestData: BaobanPcAddSizeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcAddSizeResponse>(
    prepare(baobanPcAddSizeRequestConfig, requestData),
    ...args,
  );
};

baobanPcAddSize.requestConfig = baobanPcAddSizeRequestConfig;

export const useBaobanPcAddSize = /*#__PURE__*/ makeRequestHook<
  BaobanPcAddSizeRequest,
  BaobanPcAddSizeRequestConfig,
  ReturnType<typeof baobanPcAddSize>
>(baobanPcAddSize);

export interface BaobanPcCheckGoodsKhRequest {
  /**
   * 供应商id
   */
  supply_id: string;
  /**
   * 款号
   */
  goods_kh: string;
}

export interface BaobanPcCheckGoodsKhResponse {}

type BaobanPcCheckGoodsKhRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodsLibPc/baobanPcCheckGoodsKh",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcCheckGoodsKhRequestConfig: BaobanPcCheckGoodsKhRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodsLibPc/baobanPcCheckGoodsKh",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: {
        supply_id: { type: "string", description: "供应商id" },
        goods_kh: { type: "string", description: "款号" },
      },
      required: ["supply_id", "goods_kh"],
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "baobanPcCheckGoodsKh",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcCheckGoodsKh = /*#__PURE__*/ (
  requestData: BaobanPcCheckGoodsKhRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcCheckGoodsKhResponse>(
    prepare(baobanPcCheckGoodsKhRequestConfig, requestData),
    ...args,
  );
};

baobanPcCheckGoodsKh.requestConfig = baobanPcCheckGoodsKhRequestConfig;

export const useBaobanPcCheckGoodsKh = /*#__PURE__*/ makeRequestHook<
  BaobanPcCheckGoodsKhRequest,
  BaobanPcCheckGoodsKhRequestConfig,
  ReturnType<typeof baobanPcCheckGoodsKh>
>(baobanPcCheckGoodsKh);

export interface BaobanPcGetPropOptionInfoRequest {
  /**
   * cat_id
   */
  cat_id: string;
}

export interface BaobanPcGetPropOptionInfoResponse {
  /**
   * 商品属性列表
   */
  prop_list?: {
    label: string;
    value: string;
    is_search: string;
    is_require: string;
    select_type: string;
    select: string[];
    select_new?: Array<{ size: string; value: string }>;
    is_edit?: string;
    list: {
      label: string;
      value: string;
      img: string;
      prop_size_img?: string;
    }[];
    prop_size_img?: string;
    extra_value?: { id: string; value: string }[];
  }[];
}

type BaobanPcGetPropOptionInfoRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodsLibPc/baobanPcGetPropOptionInfo",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcGetPropOptionInfoRequestConfig: BaobanPcGetPropOptionInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodsLibPc/baobanPcGetPropOptionInfo",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: { cat_id: { type: "string", description: "cat_id" } },
      required: ["cat_id"],
    },
    responseDataJsonSchema: {
      type: "object",
      properties: {
        prop_list: {
          type: "array",
          items: {
            type: "object",
            properties: {
              label: { type: "string" },
              value: { type: "string" },
              is_search: { type: "string" },
              is_require: { type: "string" },
              select_type: { type: "string" },
              select: { type: "array", items: { type: "string" } },
              list: {
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    label: { type: "string" },
                    value: { type: "string" },
                    img: { type: "string" },
                    prop_size_img: { type: "string" },
                  },
                  required: ["label", "value", "img"],
                },
              },
              prop_size_img: { type: "string" },
            },
            required: [
              "label",
              "value",
              "is_search",
              "is_require",
              "select_type",
              "select",
              "list",
            ],
          },
          description: "商品属性列表",
        },
      },
    },
    requestFunctionName: "baobanPcGetPropOptionInfo",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcGetPropOptionInfo = /*#__PURE__*/ (
  requestData: BaobanPcGetPropOptionInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcGetPropOptionInfoResponse>(
    prepare(baobanPcGetPropOptionInfoRequestConfig, requestData),
    ...args,
  );
};

baobanPcGetPropOptionInfo.requestConfig =
  baobanPcGetPropOptionInfoRequestConfig;

export const useBaobanPcGetPropOptionInfo = /*#__PURE__*/ makeRequestHook<
  BaobanPcGetPropOptionInfoRequest,
  BaobanPcGetPropOptionInfoRequestConfig,
  ReturnType<typeof baobanPcGetPropOptionInfo>
>(baobanPcGetPropOptionInfo);

export interface BaobanPcGetStyleNewTypeRequest {}

export interface BaobanPcGetStyleNewTypeResponse {
  list?: {
    label: string;
    value: string;
    children: {
      label: string;
      value: string;
    }[];
  }[];
}

type BaobanPcGetStyleNewTypeRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodsLibPc/baobanPcGetStyleNewType",
    "data",
    string,
    string,
    true
  >
>;

const baobanPcGetStyleNewTypeRequestConfig: BaobanPcGetStyleNewTypeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodsLibPc/baobanPcGetStyleNewType",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: {},
    },
    responseDataJsonSchema: {
      type: "object",
      properties: {
        list: {
          type: "array",
          items: {
            type: "object",
            properties: {
              label: { type: "string" },
              value: { type: "string" },
              children: {
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    label: { type: "string" },
                    value: { type: "string" },
                  },
                  required: ["label", "value"],
                },
              },
            },
            required: ["label", "value", "children"],
          },
        },
      },
    },
    requestFunctionName: "baobanPcGetStyleNewType",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcGetStyleNewType = /*#__PURE__*/ (
  requestData?: BaobanPcGetStyleNewTypeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcGetStyleNewTypeResponse>(
    prepare(baobanPcGetStyleNewTypeRequestConfig, requestData),
    ...args,
  );
};

baobanPcGetStyleNewType.requestConfig = baobanPcGetStyleNewTypeRequestConfig;

export const useBaobanPcGetStyleNewType = /*#__PURE__*/ makeRequestHook<
  BaobanPcGetStyleNewTypeRequest,
  BaobanPcGetStyleNewTypeRequestConfig,
  ReturnType<typeof baobanPcGetStyleNewType>
>(baobanPcGetStyleNewType);

export interface BaobanPcGetPickerGroupRequest {}

export interface BaobanPcGetPickerGroupResponse {
  /**
   * 买手组
   */
  picker_group?: string;
  /**
   * 买手代号
   */
  picker_group_code?: string;
  /**
   * 品牌名
   */
  brand_name: string;
}

type BaobanPcGetPickerGroupRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodsLibPc/baobanPcGetPickerGroup",
    "data",
    string,
    string,
    true
  >
>;

const baobanPcGetPickerGroupRequestConfig: BaobanPcGetPickerGroupRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodsLibPc/baobanPcGetPickerGroup",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: {},
    },
    responseDataJsonSchema: {
      type: "object",
      properties: {
        picker_group: { type: "string", description: "买手组" },
        picker_group_code: { type: "string", description: "买手代号" },
        brand_name: { type: "string", description: "品牌名" },
      },
      required: ["brand_name"],
    },
    requestFunctionName: "baobanPcGetPickerGroup",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcGetPickerGroup = /*#__PURE__*/ (
  requestData?: BaobanPcGetPickerGroupRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcGetPickerGroupResponse>(
    prepare(baobanPcGetPickerGroupRequestConfig, requestData),
    ...args,
  );
};

baobanPcGetPickerGroup.requestConfig = baobanPcGetPickerGroupRequestConfig;

export const useBaobanPcGetPickerGroup = /*#__PURE__*/ makeRequestHook<
  BaobanPcGetPickerGroupRequest,
  BaobanPcGetPickerGroupRequestConfig,
  ReturnType<typeof baobanPcGetPickerGroup>
>(baobanPcGetPickerGroup);

export interface BaobanPcCheckInsertGoodsPriceRequest {
  /**
   * 3级类目
   */
  cat_id: string;
  /**
   * 拿货价(正价传)
   */
  market_price: string;
  /**
   * 活动拿货价(特价传)
   */
  prefer_price: string;
  /**
   * 活动类型 0正价 1特价
   */
  goods_type: string;
}

export interface BaobanPcCheckInsertGoodsPriceResponse {
  /**
   * 错误文案提示
   */
  list?: string[];
}

type BaobanPcCheckInsertGoodsPriceRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodsLibPc/baobanPcCheckInsertGoodsPrice",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcCheckInsertGoodsPriceRequestConfig: BaobanPcCheckInsertGoodsPriceRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodsLibPc/baobanPcCheckInsertGoodsPrice",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: {
        cat_id: { type: "string", description: "3级类目" },
        market_price: { type: "string", description: "拿货价(正价传)" },
        prefer_price: { type: "string", description: "活动拿货价(特价传)" },
        goods_type: { type: "string", description: "活动类型 0正价 1特价" },
      },
      required: ["cat_id", "market_price", "prefer_price", "goods_type"],
    },
    responseDataJsonSchema: {
      type: "object",
      properties: {
        list: {
          type: "array",
          items: { type: "string" },
          description: "错误文案提示",
        },
      },
    },
    requestFunctionName: "baobanPcCheckInsertGoodsPrice",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcCheckInsertGoodsPrice = /*#__PURE__*/ (
  requestData: BaobanPcCheckInsertGoodsPriceRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcCheckInsertGoodsPriceResponse>(
    prepare(baobanPcCheckInsertGoodsPriceRequestConfig, requestData),
    ...args,
  );
};

baobanPcCheckInsertGoodsPrice.requestConfig =
  baobanPcCheckInsertGoodsPriceRequestConfig;

export const useBaobanPcCheckInsertGoodsPrice = /*#__PURE__*/ makeRequestHook<
  BaobanPcCheckInsertGoodsPriceRequest,
  BaobanPcCheckInsertGoodsPriceRequestConfig,
  ReturnType<typeof baobanPcCheckInsertGoodsPrice>
>(baobanPcCheckInsertGoodsPrice);

export interface BaobanPcCheckSaveGoodsPriceRequest {
  /**
   * 3级类目
   */
  cat_id: string;
  /**
   * 拿货价
   */
  market_price: string;
  /**
   * 活动拿货价
   */
  prefer_price: string;
  /**
   * goods_no
   */
  goods_no: string;
  goods_type: string;
}

export interface BaobanPcCheckSaveGoodsPriceResponse {
  list?: string[];
}

type BaobanPcCheckSaveGoodsPriceRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodsLibPc/baobanPcCheckSaveGoodsPrice",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcCheckSaveGoodsPriceRequestConfig: BaobanPcCheckSaveGoodsPriceRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodsLibPc/baobanPcCheckSaveGoodsPrice",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: {
        cat_id: { type: "string", description: "3级类目" },
        market_price: { type: "string", description: "拿货价" },
        prefer_price: { type: "string", description: "活动拿货价" },
        goods_no: { type: "string", description: "goods_no" },
      },
      required: ["cat_id", "market_price", "prefer_price", "goods_no"],
    },
    responseDataJsonSchema: {
      type: "object",
      properties: { list: { type: "array", items: { type: "string" } } },
    },
    requestFunctionName: "baobanPcCheckSaveGoodsPrice",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcCheckSaveGoodsPrice = /*#__PURE__*/ (
  requestData: BaobanPcCheckSaveGoodsPriceRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcCheckSaveGoodsPriceResponse>(
    prepare(baobanPcCheckSaveGoodsPriceRequestConfig, requestData),
    ...args,
  );
};

baobanPcCheckSaveGoodsPrice.requestConfig =
  baobanPcCheckSaveGoodsPriceRequestConfig;

export const useBaobanPcCheckSaveGoodsPrice = /*#__PURE__*/ makeRequestHook<
  BaobanPcCheckSaveGoodsPriceRequest,
  BaobanPcCheckSaveGoodsPriceRequestConfig,
  ReturnType<typeof baobanPcCheckSaveGoodsPrice>
>(baobanPcCheckSaveGoodsPrice);

export interface BaobanPcCheckCanApplyNoReasonGoodsRequest {
  /**
   * 3级分类id
   */
  cat_id: string;
}

export interface BaobanPcCheckCanApplyNoReasonGoodsResponse {
  /**
   * 是否平台化供应商 1是 0否
   */
  is_platform_supply?: string;
  /**
   * 是否平台化的分类 1是 0否
   */
  is_platform_cat_id?: string;
  /**
   * 无理由显示文案
   */
  platform_no_reason_text?: string;
  /**
   * 是否可以发布非无理由商品 1可以 0不可以
   */
  can_issue?: string;
  /**
   * erp的退货百分比
   */
  erp_return_percentage?: string;
  /**
   * 是否无理由商家  1是 0否
   */
  is_no_reason_supply: string;
}

type BaobanPcCheckCanApplyNoReasonGoodsRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodsLibPc/baobanPcCheckCanApplyNoReasonGoods",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcCheckCanApplyNoReasonGoodsRequestConfig: BaobanPcCheckCanApplyNoReasonGoodsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodsLibPc/baobanPcCheckCanApplyNoReasonGoods",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: { cat_id: { type: "string", description: "3级分类id" } },
      required: ["cat_id"],
    },
    responseDataJsonSchema: {
      type: "object",
      properties: {
        is_platform_supply: {
          type: "string",
          description: "是否平台化供应商 1是 0否",
        },
        is_platform_cat_id: {
          type: "string",
          description: "是否平台化的分类 1是 0否",
        },
        platform_no_reason_text: {
          type: "string",
          description: "无理由显示文案",
        },
        can_issue: {
          type: "string",
          description: "是否可以发布非无理由商品 1可以 0不可以",
        },
        erp_return_percentage: {
          type: "string",
          description: "erp的退货百分比",
        },
        is_no_reason_supply: {
          type: "string",
          description: "是否无理由商家  1是 0否",
        },
      },
      required: ["is_no_reason_supply"],
    },
    requestFunctionName: "baobanPcCheckCanApplyNoReasonGoods",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcCheckCanApplyNoReasonGoods = /*#__PURE__*/ (
  requestData: BaobanPcCheckCanApplyNoReasonGoodsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcCheckCanApplyNoReasonGoodsResponse>(
    prepare(baobanPcCheckCanApplyNoReasonGoodsRequestConfig, requestData),
    ...args,
  );
};

baobanPcCheckCanApplyNoReasonGoods.requestConfig =
  baobanPcCheckCanApplyNoReasonGoodsRequestConfig;

export const useBaobanPcCheckCanApplyNoReasonGoods =
  /*#__PURE__*/ makeRequestHook<
    BaobanPcCheckCanApplyNoReasonGoodsRequest,
    BaobanPcCheckCanApplyNoReasonGoodsRequestConfig,
    ReturnType<typeof baobanPcCheckCanApplyNoReasonGoods>
  >(baobanPcCheckCanApplyNoReasonGoods);

export interface BaobanPcMannequinListRequest {
  /**
   * 状态{0：全部，1：启用}
   */
  status: string;
}

export interface BaobanPcMannequinListResponse {
  list?: {
    /**
     * 模特id
     */
    model_id: string;
    /**
     * 头像
     */
    avatar: string;
    /**
     * 名字
     */
    name: string;
    /**
     * 状态  是否显示{1:显示,2:不显示}
     */
    status: string;
    /**
     * 模特身高
     */
    height: string;
    /**
     * 模特体重
     */
    weight: string;
    /**
     * 肩宽
     */
    shoulder: string;
    /**
     * 模特腰围
     */
    waistline: string;
    /**
     * 模特臀围
     */
    hipline: string;
    /**
     * 模特胸围
     */
    bust: string;
    /**
     * 模特腿长
     */
    leg: string;
  }[];
  total?: number;
}

type BaobanPcMannequinListRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/MannequinPc/baobanPcMannequinList",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcMannequinListRequestConfig: BaobanPcMannequinListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/MannequinPc/baobanPcMannequinList",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: {
        status: { type: "string", description: "状态{0：全部，1：启用}" },
      },
      required: ["status"],
    },
    responseDataJsonSchema: {
      type: "object",
      properties: {
        list: {
          type: "array",
          items: {
            type: "object",
            properties: {
              model_id: { type: "string", description: "模特id" },
              avatar: { type: "string", description: "头像" },
              name: { type: "string", description: "名字" },
              status: {
                type: "string",
                description: "状态  是否显示{1:显示,2:不显示}",
              },
              height: { type: "string", description: "模特身高" },
              weight: { type: "string", description: "模特体重" },
              shoulder: { type: "string", description: "肩宽" },
              waistline: { type: "string", description: "模特腰围" },
              hipline: { type: "string", description: "模特臀围" },
              bust: { type: "string", description: "模特胸围" },
              leg: { type: "string", description: "模特腿长" },
            },
            required: [
              "model_id",
              "avatar",
              "name",
              "status",
              "height",
              "weight",
              "leg",
              "bust",
              "hipline",
              "waistline",
              "shoulder",
            ],
          },
        },
        total: { type: "number" },
      },
    },
    requestFunctionName: "baobanPcMannequinList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcMannequinList = /*#__PURE__*/ (
  requestData: BaobanPcMannequinListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcMannequinListResponse>(
    prepare(baobanPcMannequinListRequestConfig, requestData),
    ...args,
  );
};

baobanPcMannequinList.requestConfig = baobanPcMannequinListRequestConfig;

export const useBaobanPcMannequinList = /*#__PURE__*/ makeRequestHook<
  BaobanPcMannequinListRequest,
  BaobanPcMannequinListRequestConfig,
  ReturnType<typeof baobanPcMannequinList>
>(baobanPcMannequinList);

export interface BaobanPcInsertGoodsLibScriptRequest {
  /**
   * 草稿id
   */
  gfs_id: string;
  /**
   * 款号
   */
  goods_kh: string;
  /**
   * 商品图片 数组
   */
  goods_img: string[];
  /**
   * 商品视频
   */
  video_url: string;
  /**
   * 商品标题
   */
  goods_name: string;
  /**
   * 拿货价
   */
  market_price: string;
  /**
   * 活动拿货价
   */
  prefer_price: string;
  /**
   * 是否支持无理由退货
   */
  is_no_reason_support: string;
  /**
   * 尺码图图片
   */
  news_img: string[];
  /**
   * 信息图
   */
  info_img: string[];
  /**
   * 限制上架时间(时间戳)
   */
  lock_on_sale_time: string;
  /**
   * 曝光给大客抢先拿时间(时间戳)
   */
  customer_advance_time: string;
  /**
   *  提前上新时间 时间戳
   */
  advance_time: string;
  /**
   * 商品类型 0正常 1特价
   */
  goods_type: string;
  /**
   * 模特信息 数组
   */
  model_param: {};
  /**
   * 颜色/尺码 数组
   */
  colorSizeData: {};
  /**
   * 配件
   */
  parts: string;
  prop?: {
    label: string;
    value: string;
    is_search: string;
    is_require: string;
    select_type: string;
    select: string[];
    select_new?: Array<{ size: string; value: string }>;
    list: {
      label: string;
      value: string;
      img: string;
    }[];
  }[];
  /**
   * 商品品类(三级品类) 数组
   */
  cat_id: string[];
  /**
   * 新风格id
   */
  style_id: string;
  /**
   * 提交还是草稿, 1提交上款, 2草稿
   */
  type: string;
  size_chart?: {
    chart_name?: string;
    cat_id?: string[];
    much_size?: number;
    chart_list?: {
      size?: string;
      showOnApp?: boolean;
      attributes?: {
        label: string;
        value: string;
        unit: string;
        is_region: boolean;
        required: boolean;
      }[];
    }[];
    default?: {
      size?: string;
      showOnApp?: boolean;
      attributes?: {
        label: string;
        value: string;
        unit: string;
        is_region: boolean;
        required: boolean;
      }[];
    }[];
  }[];
  /**
   * 特价的锁库时间
   */
  lock_day: string;
}

export interface BaobanPcInsertGoodsLibScriptResponse {
  text?: string;
}

type BaobanPcInsertGoodsLibScriptRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodsLibPc/baobanPcInsertGoodsLibScript",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcInsertGoodsLibScriptRequestConfig: BaobanPcInsertGoodsLibScriptRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodsLibPc/baobanPcInsertGoodsLibScript",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: {
        gfs_id: { type: "string", description: "草稿id" },
        goods_kh: { type: "string", description: "款号" },
        goods_img: {
          type: "array",
          items: { type: "string" },
          description: "商品图片 数组",
        },
        video_url: { type: "string", description: "商品视频" },
        goods_name: { type: "string", description: "商品标题" },
        market_price: { type: "string", description: "拿货价" },
        prefer_price: { type: "string", description: "活动拿货价" },
        is_no_reason_support: {
          type: "string",
          description: "是否支持无理由退货",
        },
        news_img: {
          type: "array",
          items: { type: "string" },
          description: "尺码图图片",
          tag: "4.38.0",
        },
        info_img: {
          type: "array",
          items: { type: "string" },
          description: "信息图",
          tag: "4.38.0",
        },
        lock_on_sale_time: {
          type: "string",
          description: "限制上架时间(时间戳)",
        },
        advance_time: { type: "string", description: " 提前上新时间 时间戳" },
        customer_advance_time: {
          type: "string",
          description: "曝光给大客抢先拿时间 时间戳",
        },
        goods_type: { type: "string", description: "商品类型 0正常 1特价" },
        model_param: {
          type: "object",
          properties: {},
          description: "模特信息 数组",
        },
        colorSizeData: {
          type: "object",
          properties: {},
          description: "颜色/尺码 数组",
        },
        parts: { type: "string", description: "配件" },
        prop: {
          type: "array",
          items: {
            type: "object",
            properties: {
              label: { type: "string" },
              value: { type: "string" },
              is_search: { type: "string" },
              is_require: { type: "string" },
              select_type: { type: "string" },
              select: { type: "array", items: { type: "string" } },
              list: {
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    label: { type: "string" },
                    value: { type: "string" },
                    img: { type: "string" },
                  },
                  required: ["label", "value", "img"],
                },
              },
            },
            required: [
              "label",
              "value",
              "is_search",
              "is_require",
              "select_type",
              "select",
              "list",
            ],
          },
        },
        cat_id: {
          type: "array",
          items: { type: "string" },
          description: "商品品类(三级品类) 数组",
        },
        style_id: { type: "string", description: "新风格id" },
        type: { type: "string", description: "提交还是草稿, 1提交上款, 2草稿" },
        size_chart: {
          type: "array",
          items: {
            type: "object",
            properties: {
              chart_name: { type: "string" },
              cat_id: { type: "array", items: { type: "string" } },
              much_size: { type: "number" },
              chart_list: {
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    size: { type: "string" },
                    showOnApp: { type: "boolean" },
                    attributes: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          label: { type: "string" },
                          value: { type: "string" },
                          unit: { type: "string" },
                          is_region: { type: "boolean" },
                          required: { type: "boolean" },
                        },
                        required: [
                          "label",
                          "value",
                          "unit",
                          "is_region",
                          "required",
                        ],
                      },
                    },
                  },
                },
              },
              default: {
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    size: { type: "string" },
                    showOnApp: { type: "boolean" },
                    attributes: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          label: { type: "string" },
                          value: { type: "string" },
                          unit: { type: "string" },
                          is_region: { type: "boolean" },
                          required: { type: "boolean" },
                        },
                        required: [
                          "label",
                          "value",
                          "unit",
                          "is_region",
                          "required",
                        ],
                      },
                    },
                  },
                },
              },
            },
          },
        },
        lock_day: { type: "string", description: "特价的锁库时间" },
      },
      required: [
        "gfs_id",
        "goods_kh",
        "goods_img",
        "video_url",
        "goods_name",
        "market_price",
        "prefer_price",
        "is_no_reason_support",
        "lock_on_sale_time",
        "news_img",
        "parts",
        "colorSizeData",
        "model_param",
        "goods_type",
        "advance_time",
        "customer_advance_time",
        "cat_id",
        "style_id",
        "type",
        "lock_day",
        "info_img",
      ],
    },
    responseDataJsonSchema: {
      type: "object",
      properties: { text: { type: "string" } },
    },
    requestFunctionName: "baobanPcInsertGoodsLibScript",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcInsertGoodsLibScript = /*#__PURE__*/ (
  requestData: BaobanPcInsertGoodsLibScriptRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcInsertGoodsLibScriptResponse>(
    prepare(baobanPcInsertGoodsLibScriptRequestConfig, requestData),
    ...args,
  );
};

baobanPcInsertGoodsLibScript.requestConfig =
  baobanPcInsertGoodsLibScriptRequestConfig;

export const useBaobanPcInsertGoodsLibScript = /*#__PURE__*/ makeRequestHook<
  BaobanPcInsertGoodsLibScriptRequest,
  BaobanPcInsertGoodsLibScriptRequestConfig,
  ReturnType<typeof baobanPcInsertGoodsLibScript>
>(baobanPcInsertGoodsLibScript);

export interface BaobanPcGetGoodsInfoRequest {
  /**
   * goods_no
   */
  goods_no: string;
}

export interface BaobanPcGetGoodsInfoResponse {
  goods_kh?: string;
  goods_type?: string;
  goods_name?: string;
  market_price?: string;
  colorSizeData?: {
    key: string;
    label: string;
    thumb: {
      name?: string;
    };
    size: {
      sku: string;
      key: string;
      label: string;
      real_stock: string;
      sale_stock: string;
      virtual_stock: string;
      supply_stock: string;
      status: boolean;
      update_stock: string;
      sku_sort: string;
      schedule_day: string;
      sku_name: string;
      in_stock_num: string;
      pre_in_stock_num: string;
    }[];
  }[];
  lock_on_sale_time?: string;
  model_param?: {
    model_id?: string;
    avatar?: string;
    name?: string;
    status?: string;
    height?: string;
    weight?: string;
    shoulder?: string;
    waistline?: string;
    hipline?: string;
    bust?: string;
    leg?: string;
    size?: string;
    comfortLevel?: string;
    modelId?: string;
  }[];
  size_chart?: {
    chart_name?: string;
    cat_id?: string[];
    much_size?: number;
    chart_list?: {
      size: string;
      showOnApp: boolean;
      attributes: {
        label: string;
        value: string;
        unit: string;
        is_region: boolean;
        required: boolean;
      }[];
    }[];
    default?: {
      size?: string;
      showOnApp?: boolean;
      attributes?: {
        label: string;
        value: string;
        unit: string;
        is_region: boolean;
        required: boolean;
      }[];
    }[];
  }[];
  cat_id?: string[];
  prefer_price?: string;
  prop_list?: {
    label: string;
    value: string;
    is_search: string;
    is_require: string;
    select_type: string;
    select: string[];
    list: {
      label: string;
      value: string;
      img: string;
      weight: string;
    }[];
  }[];
  style_id?: string;
  model_img?: string[];
  real_img?: string[];
  main_img?: string[];
  /**
   * 尺码图
   */
  news_img?: string[];
  /**
   * 信息图
   */
  info_img?: string[];
  customize_special?: string;
  customize_remark?: string;
  video_url?: string;
  parts?: string;
  picker_group_code?: string;
  is_no_reason_support?: string;
  is_advance_support?: string;
  advance_time?: string;
  customer_advance_time?: string;
  is_platform_cat_id?: string;
  unsale_date?: string;
  if_lock_time_end?: string;
  delivery_day_data?: any;
  official_size?: string[];
  official_model?: string[];
  official_size_no_padding?: string[];
  official_model_no_padding?: string[];
  fabric_img?: string[];
}

type BaobanPcGetGoodsInfoRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodsLibPc/baobanPcGetGoodsInfo",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcGetGoodsInfoRequestConfig: BaobanPcGetGoodsInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodsLibPc/baobanPcGetGoodsInfo",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: { goods_no: { type: "string", description: "goods_no" } },
      required: ["goods_no"],
    },
    responseDataJsonSchema: {
      type: "object",
      properties: {
        goods_kh: { type: "string" },
        goods_type: { type: "string" },
        goods_name: { type: "string" },
        market_price: { type: "string" },
        colorSizeData: {
          type: "array",
          items: {
            type: "object",
            properties: {
              key: { type: "string" },
              label: { type: "string" },
              thumb: {
                type: "object",
                properties: { name: { type: "string" } },
              },
              size: {
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    sku: { type: "string" },
                    key: { type: "string" },
                    label: { type: "string" },
                    real_stock: { type: "string" },
                    sale_stock: { type: "string" },
                    virtual_stock: { type: "string" },
                    supply_stock: { type: "string" },
                    status: { type: "boolean" },
                    update_stock: { type: "string" },
                    sku_sort: { type: "string" },
                    schedule_day: { type: "string" },
                    sku_name: { type: "string" },
                    in_stock_num: { type: "string" },
                    pre_in_stock_num: { type: "string" },
                  },
                  required: [
                    "sku",
                    "key",
                    "label",
                    "real_stock",
                    "sale_stock",
                    "virtual_stock",
                    "supply_stock",
                    "status",
                    "update_stock",
                    "sku_sort",
                    "schedule_day",
                    "sku_name",
                    "in_stock_num",
                    "pre_in_stock_num",
                  ],
                },
              },
            },
            required: ["key", "label", "thumb", "size"],
          },
        },
        lock_on_sale_time: { type: "string" },
        model_param: {
          type: "array",
          items: {
            type: "object",
            properties: {
              model_id: { type: "string" },
              avatar: { type: "string" },
              name: { type: "string" },
              status: { type: "string" },
              height: { type: "string" },
              weight: { type: "string" },
              shoulder: { type: "string" },
              waistline: { type: "string" },
              hipline: { type: "string" },
              bust: { type: "string" },
              leg: { type: "string" },
              size: { type: "string" },
              comfortLevel: { type: "string" },
            },
          },
        },
        size_chart: {
          type: "array",
          items: {
            type: "object",
            properties: {
              chart_name: { type: "string" },
              cat_id: { type: "array", items: { type: "string" } },
              much_size: { type: "number" },
              chart_list: {
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    size: { type: "string" },
                    showOnApp: { type: "boolean" },
                    attributes: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          label: { type: "string" },
                          value: { type: "string" },
                          unit: { type: "string" },
                          is_region: { type: "boolean" },
                          required: { type: "boolean" },
                        },
                        required: [
                          "label",
                          "value",
                          "unit",
                          "is_region",
                          "required",
                        ],
                      },
                    },
                  },
                  required: ["size", "showOnApp", "attributes"],
                },
              },
              default: {
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    size: { type: "string" },
                    showOnApp: { type: "boolean" },
                    attributes: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          label: { type: "string" },
                          value: { type: "string" },
                          unit: { type: "string" },
                          is_region: { type: "boolean" },
                          required: { type: "boolean" },
                        },
                        required: [
                          "label",
                          "value",
                          "unit",
                          "is_region",
                          "required",
                        ],
                      },
                    },
                  },
                },
              },
            },
          },
        },
        cat_id: { type: "array", items: { type: "string" } },
        prefer_price: { type: "string" },
        prop_list: {
          type: "array",
          items: {
            type: "object",
            properties: {
              label: { type: "string" },
              value: { type: "string" },
              is_search: { type: "string" },
              is_require: { type: "string" },
              select_type: { type: "string" },
              select: { type: "array", items: { type: "string" } },
              list: {
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    label: { type: "string" },
                    value: { type: "string" },
                    img: { type: "string" },
                    weight: { type: "string" },
                  },
                  required: ["label", "value", "img", "weight"],
                },
              },
            },
            required: [
              "label",
              "value",
              "is_search",
              "is_require",
              "select_type",
              "select",
              "list",
            ],
          },
        },
        style_id: { type: "string" },
        model_img: { type: "array", items: { type: "string" } },
        real_img: { type: "array", items: { type: "string" } },
        news_img: {
          type: "array",
          items: { type: "string" },
          tag: "4.38.0",
          description: "尺码图",
        },
        info_img: {
          type: "array",
          items: { type: "string" },
          tag: "4.38.0",
          description: "信息图",
        },
        customize_special: { type: "string" },
        customize_remark: { type: "string" },
        video_url: { type: "string" },
        parts: { type: "string" },
        picker_group_code: { type: "string" },
        is_no_reason_support: { type: "string" },
        is_advance_support: { type: "string" },
        advance_time: { type: "string" },
        customer_advance_time: { type: "string" },
        is_platform_cat_id: { type: "string" },
        unsale_date: { type: "string" },
        if_lock_time_end: { type: "string" },
      },
    },
    requestFunctionName: "baobanPcGetGoodsInfo",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcGetGoodsInfo = /*#__PURE__*/ (
  requestData: BaobanPcGetGoodsInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcGetGoodsInfoResponse>(
    prepare(baobanPcGetGoodsInfoRequestConfig, requestData),
    ...args,
  );
};

baobanPcGetGoodsInfo.requestConfig = baobanPcGetGoodsInfoRequestConfig;

export const useBaobanPcGetGoodsInfo = /*#__PURE__*/ makeRequestHook<
  BaobanPcGetGoodsInfoRequest,
  BaobanPcGetGoodsInfoRequestConfig,
  ReturnType<typeof baobanPcGetGoodsInfo>
>(baobanPcGetGoodsInfo);

export interface BaobanPcGetSizeChartRequest {
  /**
   * cat_id
   */
  cat_id: string[][];
  /**
   * size_id
   */
  size_id: string[];
  size_names: string[];
}

export interface BaobanPcGetSizeChartResponse {
  list?: {
    chart_name?: string;
    cat_id?: string[];
    much_size?: number;
    chart_list?: {
      size: string;
      showOnApp: boolean;
      attributes: {
        label: string;
        value: string;
        unit: string;
        is_region: boolean;
        required: boolean;
      }[];
    }[];
    default?: {
      size?: string;
      showOnApp?: boolean;
      attributes?: {
        label: string;
        value: string;
        unit: string;
        is_region: boolean;
        required: boolean;
      }[];
    }[];
  }[];
}

type BaobanPcGetSizeChartRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodsLibPc/baobanPcGetSizeChart",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcGetSizeChartRequestConfig: BaobanPcGetSizeChartRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodsLibPc/baobanPcGetSizeChart",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: {
        cat_id: {
          type: "array",
          items: { type: "array", items: { type: "string" } },
          description: "cat_id",
        },
        size_id: {
          type: "array",
          items: { type: "string" },
          description: "size_id",
        },
        size_names: { type: "array", items: { type: "string" } },
      },
      required: ["cat_id", "size_id", "size_names"],
    },
    responseDataJsonSchema: {
      type: "object",
      properties: {
        list: {
          type: "array",
          items: {
            type: "object",
            properties: {
              chart_name: { type: "string" },
              cat_id: { type: "array", items: { type: "string" } },
              much_size: { type: "number" },
              chart_list: {
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    size: { type: "string" },
                    showOnApp: { type: "boolean" },
                    attributes: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          label: { type: "string" },
                          value: { type: "string" },
                          unit: { type: "string" },
                          is_region: { type: "boolean" },
                          required: { type: "boolean" },
                        },
                        required: [
                          "label",
                          "value",
                          "unit",
                          "is_region",
                          "required",
                        ],
                      },
                    },
                  },
                  required: ["size", "showOnApp", "attributes"],
                },
              },
              default: {
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    size: { type: "string" },
                    showOnApp: { type: "boolean" },
                    attributes: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          label: { type: "string" },
                          value: { type: "string" },
                          unit: { type: "string" },
                          is_region: { type: "boolean" },
                          required: { type: "boolean" },
                        },
                        required: [
                          "label",
                          "value",
                          "unit",
                          "is_region",
                          "required",
                        ],
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
    requestFunctionName: "baobanPcGetSizeChart",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcGetSizeChart = /*#__PURE__*/ (
  requestData: BaobanPcGetSizeChartRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcGetSizeChartResponse>(
    prepare(baobanPcGetSizeChartRequestConfig, requestData),
    ...args,
  );
};

baobanPcGetSizeChart.requestConfig = baobanPcGetSizeChartRequestConfig;

export const useBaobanPcGetSizeChart = /*#__PURE__*/ makeRequestHook<
  BaobanPcGetSizeChartRequest,
  BaobanPcGetSizeChartRequestConfig,
  ReturnType<typeof baobanPcGetSizeChart>
>(baobanPcGetSizeChart);

export interface BaobanPcUpdateGoodsLibScriptRequest {
  /**
   * 款号
   */
  goods_kh: string;
  /**
   * 全部图片(不用去除http前缀) 数组
   */
  all_img: string[];
  /**
   * 重新设置的主图 数组
   */
  set_main: string[];
  /**
   * 模特图
   */
  model_img: string[];
  /**
   * 添加模特图
   */
  field_5: string[];
  /**
   * 删除模特图
   */
  del_model_img: string[];
  /**
   * 实拍图
   */
  real_img: string[];
  /**
   * 添加实拍图
   */
  add_real_img: string[];
  /**
   * 删除实拍图
   */
  del_real_img: string[];
  /**
   * 信息图
   */
  info_img: string[];
  /**
   * 添加信息图
   */
  add_info_img: string[];
  /**
   * 删除信息图
   */
  del_info_img: string[];
  /**
   * 尺码图
   */
  news_img: string[];
  /**
   * 添加尺码图
   */
  add_news_img: string[];
  /**
   * 删除尺码图
   */
  del_news_img: string[];
  /**
   * 商品类型 0正常 1特价
   */
  goods_type: string;
  /**
   * 添加视频 [  {    "duration(视频长度)": 2.99,    "video_url(video的url)": "https://img4.yishouapp.com/obs/baob/e315f32bead55b4a1aef437b03a69373.mp4"  }]
   */
  add_video: string[];
  /**
   * 商品标题
   */
  goods_name: string;
  /**
   * 拿货价
   */
  market_price: string;
  /**
   * 活动拿货价
   */
  prefer_price: string;
  /**
   * 设置锁库时间
   */
  lock_day: string;
  /**
   * 颜色/尺码
   */
  colorSizeData: {};
  /**
   * 配件
   */
  parts: string;
  /**
   * 商品属性
   */
  prop: {};
  /**
   * 新风格id
   */
  style_id: string;
  /**
   * 是否编辑了排序，如果用户编辑了排序，请传入1，方便后端判, 默认0
   */
  is_change_sort: string;
  /**
   * 删除的视频
   */
  del_video: {};
  /**
   * 请求来源{1:编辑商品,2:修改库存}
   */
  apply_type: string;
}

export interface BaobanPcUpdateGoodsLibScriptResponse {}

type BaobanPcUpdateGoodsLibScriptRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodsLibPc/baobanPcUpdateGoodsLibScript",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcUpdateGoodsLibScriptRequestConfig: BaobanPcUpdateGoodsLibScriptRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodsLibPc/baobanPcUpdateGoodsLibScript",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: {
        goods_kh: { type: "string", description: "款号" },
        all_img: {
          type: "array",
          items: { type: "string" },
          description: "全部图片(不用去除http前缀) 数组",
        },
        set_main: {
          type: "array",
          items: { type: "string" },
          description: "重新设置的主图 数组",
        },
        model_img: {
          type: "array",
          items: { type: "string" },
          description: "模特图",
          tag: "4.38.0",
        },
        field_5: {
          type: "array",
          items: { type: "string" },
          description: "添加模特图",
        },
        del_model_img: {
          type: "array",
          items: { type: "string" },
          description: "删除模特图",
          tag: "4.38.0",
        },
        real_img: {
          type: "array",
          items: { type: "string" },
          description: "实拍图",
        },
        add_real_img: {
          type: "array",
          items: { type: "string" },
          description: "添加实拍图",
          tag: "4.38.0",
        },
        del_real_img: {
          type: "array",
          items: { type: "string" },
          description: "删除实拍图",
          tag: "4.38.0",
        },
        info_img: {
          type: "array",
          items: { type: "string" },
          description: "信息图",
          tag: "4.38.0",
        },
        add_info_img: {
          type: "array",
          items: { type: "string" },
          description: "添加信息图",
          tag: "4.38.0",
        },
        del_info_img: {
          type: "array",
          items: { type: "string" },
          description: "删除信息图",
          tag: "4.38.0",
        },
        news_img: {
          type: "array",
          items: { type: "string" },
          description: "尺码图",
          tag: "4.38.0",
        },
        add_news_img: {
          type: "array",
          items: { type: "string" },
          description: "添加尺码图",
          tag: "4.38.0",
        },
        del_news_img: {
          type: "array",
          items: { type: "string" },
          description: "删除尺码图",
          tag: "4.38.0",
        },
        goods_type: { type: "string", description: "商品类型 0正常 1特价" },
        add_video: {
          type: "array",
          items: { type: "string" },
          description:
            '添加视频 [  {    "duration(视频长度)": 2.99,    "video_url(video的url)": "https://img4.yishouapp.com/obs/baob/e315f32bead55b4a1aef437b03a69373.mp4"  }]',
        },
        goods_name: { type: "string", description: "商品标题" },
        market_price: { type: "string", description: "拿货价" },
        prefer_price: { type: "string", description: "活动拿货价" },
        lock_day: { type: "string", description: "设置锁库时间" },
        colorSizeData: {
          type: "object",
          properties: {},
          description: "颜色/尺码",
        },
        parts: { type: "string", description: "配件" },
        prop: { type: "object", properties: {}, description: "商品属性" },
        style_id: { type: "string", description: "新风格id" },
        is_change_sort: {
          type: "string",
          description:
            "是否编辑了排序，如果用户编辑了排序，请传入1，方便后端判, 默认0",
        },
        del_video: {
          type: "object",
          properties: {},
          description: "删除的视频",
        },
        apply_type: {
          type: "string",
          description: "请求来源{1:编辑商品,2:修改库存}",
        },
      },
      required: [
        "goods_kh",
        "all_img",
        "set_main",
        "model_img",
        "del_model_img",
        "add_real_img",
        "del_real_img",
        "add_info_img",
        "del_info_img",
        "goods_type",
        "add_video",
        "market_price",
        "prefer_price",
        "lock_day",
        "colorSizeData",
        "goods_name",
        "style_id",
        "prop",
        "parts",
        "del_video",
        "is_change_sort",
        "apply_type",
        "del_news_img",
        "add_news_img",
        "field_5",
        "real_img",
        "info_img",
        "news_img",
      ],
    },
    responseDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: {},
    },
    requestFunctionName: "baobanPcUpdateGoodsLibScript",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcUpdateGoodsLibScript = /*#__PURE__*/ (
  requestData: BaobanPcUpdateGoodsLibScriptRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcUpdateGoodsLibScriptResponse>(
    prepare(baobanPcUpdateGoodsLibScriptRequestConfig, requestData),
    ...args,
  );
};

baobanPcUpdateGoodsLibScript.requestConfig =
  baobanPcUpdateGoodsLibScriptRequestConfig;

export const useBaobanPcUpdateGoodsLibScript = /*#__PURE__*/ makeRequestHook<
  BaobanPcUpdateGoodsLibScriptRequest,
  BaobanPcUpdateGoodsLibScriptRequestConfig,
  ReturnType<typeof baobanPcUpdateGoodsLibScript>
>(baobanPcUpdateGoodsLibScript);

export interface BaobanPcGetDraftInfoRequest {
  /**
   * 草稿id
   */
  gfs_id: string;
}

export interface BaobanPcGetDraftInfoResponse {
  gfs_id?: string;
  goods_kh?: string;
  model_img?: string[];
  real_img?: string[];
  /**
   * 尺码图
   */
  news_img?: string[];
  prop?: {
    label: string;
    value: string;
    is_search: string;
    is_require: string;
    select_type: string;
    select: string[];
    select_new?: Array<{ size: string; value: string }>;
    list: {
      label: string;
      value: string;
      img: string;
    }[];
  }[];
  /**
   * 信息图
   */
  info_img?: string[];
  /**
   * 面料成分信息图
   */
  fabric_img?: string[];
  model_info_img?: string;
  style_id?: string;
  goods_name?: string;
  market_price?: string;
  prefer_price?: string;
  cat_id?: string[];
  model_param?: {
    modelName?: string;
    model_id?: string;
    avatar?: string;
    name?: string;
    status?: string;
    height?: string;
    weight?: string;
    shoulder?: string;
    waistline?: string;
    hipline?: string;
    bust?: string;
    leg?: string;
    size?: string;
    size_id?: string;
    comfortLevel?: string;
    modelId?: string;
  }[];
  lock_on_sale_time?: string;
  video_url?: string;
  lock_day?: string;
  goods_type?: number;
  colorSizeData?: {
    key?: string;
    label?: string;
    thumb?: {
      name?: string;
    };
    size?: {
      key?: string;
      label?: string;
      sku?: string;
      sku_name?: string;
      sale_stock?: string;
      pre_in_stock_num?: string;
      update_stock?: string;
      status?: boolean;
    }[];
  }[];
  size_chart?: {
    chart_name?: string;
    cat_id?: string[];
    much_size?: number;
    chart_list?: {
      size: string;
      showOnApp: boolean;
      attributes: {
        label: string;
        value: string;
        unit: string;
        is_region: boolean;
        required: boolean;
      }[];
    }[];
    default?: {
      size?: string;
      showOnApp?: boolean;
      attributes?: {
        label: string;
        value: string;
        unit: string;
        is_region: boolean;
        required: boolean;
      }[];
    }[];
  }[];
  is_advance_support?: string;
  advance_time?: string;
  customer_advance_time?: string;
  is_no_reason_support?: string;
  customize_special?: string;
  customize_remark?: string;
  shopId?: string;
  suit_ids?: string;
  parts?: string;
  supply_id?: string;
  baob_user_name?: string;
  type?: number;
  goods_img?: string[];
  /**
   * 尺码图
   */
  size_img?: string[];
  official_size?: string[];
  official_model?: string[];
  official_size_no_padding?: string[];
  official_model_no_padding?: string[];
}

type BaobanPcGetDraftInfoRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodsLibPc/baobanPcGetDraftInfo",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcGetDraftInfoRequestConfig: BaobanPcGetDraftInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodsLibPc/baobanPcGetDraftInfo",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: { gfs_id: { type: "string", description: "草稿id" } },
      required: ["gfs_id"],
    },
    responseDataJsonSchema: {
      type: "object",
      properties: {
        gfs_id: { type: "string" },
        goods_kh: { type: "string" },
        model_img: { type: "array", items: { type: "string" } },
        real_img: { type: "array", items: { type: "string" } },
        news_img: {
          type: "array",
          items: { type: "string" },
          tag: "4.38.0",
          description: "尺码图",
        },
        prop: {
          type: "array",
          items: {
            type: "object",
            properties: {
              label: { type: "string" },
              value: { type: "string" },
              is_search: { type: "string" },
              is_require: { type: "string" },
              select_type: { type: "string" },
              select: { type: "array", items: { type: "string" } },
              list: {
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    label: { type: "string" },
                    value: { type: "string" },
                    img: { type: "string" },
                  },
                  required: ["label", "value", "img"],
                },
              },
            },
            required: [
              "label",
              "value",
              "is_search",
              "is_require",
              "select_type",
              "select",
              "list",
            ],
          },
        },
        info_img: {
          type: "array",
          items: { type: "string" },
          tag: "4.38.0",
          description: "信息图",
        },
        model_info_img: { type: "string" },
        style_id: { type: "string" },
        goods_name: { type: "string" },
        market_price: { type: "string" },
        prefer_price: { type: "string" },
        cat_id: { type: "array", items: { type: "string" } },
        model_param: {
          type: "array",
          items: {
            type: "object",
            properties: {
              modelName: { type: "string" },
              model_id: { type: "string" },
              avatar: { type: "string" },
              name: { type: "string" },
              status: { type: "string" },
              height: { type: "string" },
              weight: { type: "string" },
              shoulder: { type: "string" },
              waistline: { type: "string" },
              hipline: { type: "string" },
              bust: { type: "string" },
              leg: { type: "string" },
              size: { type: "string" },
              size_id: { type: "string" },
              comfortLevel: { type: "string" },
            },
            required: [],
          },
        },
        lock_on_sale_time: { type: "string" },
        video_url: { type: "string" },
        lock_day: { type: "string" },
        goods_type: { type: "number" },
        colorSizeData: {
          type: "array",
          items: {
            type: "object",
            properties: {
              key: { type: "string" },
              label: { type: "string" },
              thumb: {
                type: "object",
                properties: { name: { type: "string" } },
              },
              size: {
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    key: { type: "string" },
                    label: { type: "string" },
                    sku: { type: "string" },
                    sku_name: { type: "string" },
                    sale_stock: { type: "string" },
                    pre_in_stock_num: { type: "string" },
                    update_stock: { type: "string" },
                    status: { type: "boolean" },
                  },
                },
              },
            },
          },
        },
        size_chart: {
          type: "array",
          items: {
            type: "object",
            properties: {
              chart_name: { type: "string" },
              cat_id: { type: "array", items: { type: "string" } },
              much_size: { type: "number" },
              chart_list: {
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    size: { type: "string" },
                    showOnApp: { type: "boolean" },
                    attributes: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          label: { type: "string" },
                          value: { type: "string" },
                          unit: { type: "string" },
                          is_region: { type: "boolean" },
                          required: { type: "boolean" },
                        },
                        required: [
                          "label",
                          "value",
                          "unit",
                          "is_region",
                          "required",
                        ],
                      },
                    },
                  },
                  required: ["size", "showOnApp", "attributes"],
                },
              },
              default: {
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    size: { type: "string" },
                    showOnApp: { type: "boolean" },
                    attributes: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          label: { type: "string" },
                          value: { type: "string" },
                          unit: { type: "string" },
                          is_region: { type: "boolean" },
                          required: { type: "boolean" },
                        },
                        required: [
                          "label",
                          "value",
                          "unit",
                          "is_region",
                          "required",
                        ],
                      },
                    },
                  },
                },
              },
            },
          },
        },
        is_advance_support: { type: "string" },
        advance_time: { type: "string" },
        customer_advance_time: { type: "string" },
        is_no_reason_support: { type: "string" },
        customize_special: { type: "string" },
        customize_remark: { type: "string" },
        shopId: { type: "string" },
        suit_ids: { type: "string" },
        parts: { type: "string" },
        supply_id: { type: "string" },
        baob_user_name: { type: "string" },
        type: { type: "number" },
        goods_img: { type: "array", items: { type: "string" } },
        size_img: {
          type: "array",
          items: { type: "string" },
          description: "尺码图",
        },
      },
    },
    requestFunctionName: "baobanPcGetDraftInfo",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcGetDraftInfo = /*#__PURE__*/ (
  requestData: BaobanPcGetDraftInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcGetDraftInfoResponse>(
    prepare(baobanPcGetDraftInfoRequestConfig, requestData),
    ...args,
  );
};

baobanPcGetDraftInfo.requestConfig = baobanPcGetDraftInfoRequestConfig;

export const useBaobanPcGetDraftInfo = /*#__PURE__*/ makeRequestHook<
  BaobanPcGetDraftInfoRequest,
  BaobanPcGetDraftInfoRequestConfig,
  ReturnType<typeof baobanPcGetDraftInfo>
>(baobanPcGetDraftInfo);

export interface BaobanPcInsertGoodsLibNoReviewRequest {
  co_ids?: string[];
  si_ids?: string[];
  isSizeImageUpload?: string;
  prop_list?: {
    select: string[];
  }[];
  model_img?: string[];
  real_img?: string[];
  /**
   * 尺码图
   */
  news_img?: string[];
  /**
   * 信息图
   */
  info_img?: string[];
  size_img?: string[];
  video_url?: string;
  advance_time?: string;
  customer_advance_time?: string;
  goods_no?: string;
  gfs_id?: string;
  cat_id?: string[];
  colorSizeData?: {
    key?: string;
    label?: string;
    thumb?: {
      name?: string;
    };
    size?: {
      key?: string;
      label?: string;
      sku?: string;
      sku_name?: string;
      sale_stock?: string;
      pre_in_stock_num?: string;
      update_stock?: string;
      status?: boolean;
    }[];
  }[];
  customize_remark?: string;
  customize_special?: string;
  goods_kh?: string;
  goods_name?: string;
  goods_type?: string;
  is_advance_support?: string;
  is_no_reason_support?: string;
  lock_day?: string;
  lock_on_sale_time?: string;
  market_price?: string;
  model_param?: {
    modelName?: string;
    model_id?: string;
    avatar?: string;
    name?: string;
    status?: string;
    height?: string;
    weight?: string;
    shoulder?: string;
    waistline?: string;
    hipline?: string;
    bust?: string;
    leg?: string;
    size_id?: string;
    comfortLevel?: string;
    size?: string;
    modelId?: string;
  }[];
  parts?: string;
  prefer_price?: string;
  prop?: {
    label: string;
    value: string;
    is_search: string;
    is_require: string;
    select_type: string;
    select: string[];
    select_new?: Array<{ size: string; value: string }>;
    list: {
      label: string;
      value: string;
      img: string;
    }[];
  }[];
  size_chart?: {
    chart_name?: string;
    cat_id?: string[];
    much_size?: number;
    chart_list?: {
      size?: string;
      showOnApp?: boolean;
      attributes?: {
        label: string;
        value: string;
        unit: string;
        is_region: boolean;
        required: boolean;
      }[];
    }[];
    default?: {
      size?: string;
      showOnApp?: boolean;
      attributes?: {
        label: string;
        value: string;
        unit: string;
        is_region: boolean;
        required: boolean;
      }[];
    }[];
  }[];
  style_id?: string;
  model_info_img?: string;
}

export interface BaobanPcInsertGoodsLibNoReviewResponse {
  text?: string;
}

type BaobanPcInsertGoodsLibNoReviewRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodsLibPc/baobanPcInsertGoodsLibNoReview",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcInsertGoodsLibNoReviewRequestConfig: BaobanPcInsertGoodsLibNoReviewRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodsLibPc/baobanPcInsertGoodsLibNoReview",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      $schema: "http://json-schema.org/draft-04/schema#",
      type: "object",
      properties: {
        co_ids: { type: "array", items: { type: "string" } },
        si_ids: { type: "array", items: { type: "string" } },
        isSizeImageUpload: { type: "string" },
        prop_list: {
          type: "array",
          items: {
            type: "object",
            properties: {
              select: { type: "array", items: { type: "string" } },
            },
            required: ["select"],
          },
        },
        model_img: { type: "array", items: { type: "string" } },
        real_img: { type: "array", items: { type: "string" } },
        news_img: {
          type: "array",
          items: { type: "string" },
          description: "尺码图",
          tag: "4.38.0",
        },
        info_img: {
          type: "array",
          items: { type: "string" },
          tag: "4.38.0",
          description: "信息图",
        },
        size_img: { type: "array", items: { type: "string" } },
        video_url: { type: "string" },
        advance_time: { type: "string" },
        customer_advance_time: { type: "string" },
        goods_no: { type: "string" },
        gfs_id: { type: "string" },
        cat_id: { type: "array", items: { type: "string" } },
        colorSizeData: {
          type: "array",
          items: {
            type: "object",
            properties: {
              key: { type: "string" },
              label: { type: "string" },
              thumb: {
                type: "object",
                properties: { name: { type: "string" } },
              },
              size: {
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    key: { type: "string" },
                    label: { type: "string" },
                    sku: { type: "string" },
                    sku_name: { type: "string" },
                    sale_stock: { type: "string" },
                    pre_in_stock_num: { type: "string" },
                    update_stock: { type: "string" },
                    status: { type: "boolean" },
                  },
                },
              },
            },
          },
        },
        customize_remark: { type: "string" },
        customize_special: { type: "string" },
        goods_kh: { type: "string" },
        goods_name: { type: "string" },
        goods_type: { type: "string" },
        is_advance_support: { type: "string" },
        is_no_reason_support: { type: "string" },
        lock_day: { type: "string" },
        lock_on_sale_time: { type: "string" },
        market_price: { type: "string" },
        model_param: {
          type: "array",
          items: {
            type: "object",
            properties: {
              modelName: { type: "string" },
              model_id: { type: "string" },
              avatar: { type: "string" },
              name: { type: "string" },
              status: { type: "string" },
              height: { type: "string" },
              weight: { type: "string" },
              shoulder: { type: "string" },
              waistline: { type: "string" },
              hipline: { type: "string" },
              bust: { type: "string" },
              leg: { type: "string" },
              size_id: { type: "string" },
              comfortLevel: { type: "string" },
              size: { type: "string" },
            },
            required: [],
          },
        },
        parts: { type: "string" },
        prefer_price: { type: "string" },
        prop: {
          type: "array",
          items: {
            type: "object",
            properties: {
              label: { type: "string" },
              value: { type: "string" },
              is_search: { type: "string" },
              is_require: { type: "string" },
              select_type: { type: "string" },
              select: { type: "array", items: { type: "string" } },
              list: {
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    label: { type: "string" },
                    value: { type: "string" },
                    img: { type: "string" },
                  },
                  required: ["label", "value", "img"],
                },
              },
            },
            required: [
              "label",
              "value",
              "is_search",
              "is_require",
              "select_type",
              "select",
              "list",
            ],
          },
        },
        size_chart: {
          type: "array",
          items: {
            type: "object",
            properties: {
              chart_name: { type: "string" },
              cat_id: { type: "array", items: { type: "string" } },
              much_size: { type: "number" },
              chart_list: {
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    size: { type: "string" },
                    showOnApp: { type: "boolean" },
                    attributes: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          label: { type: "string" },
                          value: { type: "string" },
                          unit: { type: "string" },
                          is_region: { type: "boolean" },
                          required: { type: "boolean" },
                        },
                        required: [
                          "label",
                          "value",
                          "unit",
                          "is_region",
                          "required",
                        ],
                      },
                    },
                  },
                },
              },
              default: {
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    size: { type: "string" },
                    showOnApp: { type: "boolean" },
                    attributes: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          label: { type: "string" },
                          value: { type: "string" },
                          unit: { type: "string" },
                          is_region: { type: "boolean" },
                          required: { type: "boolean" },
                        },
                        required: [
                          "label",
                          "value",
                          "unit",
                          "is_region",
                          "required",
                        ],
                      },
                    },
                  },
                },
              },
            },
          },
        },
        style_id: { type: "string" },
        model_info_img: { type: "string" },
      },
      required: [],
    },
    responseDataJsonSchema: {
      type: "object",
      properties: { text: { type: "string" } },
    },
    requestFunctionName: "baobanPcInsertGoodsLibNoReview",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcInsertGoodsLibNoReview = /*#__PURE__*/ (
  requestData: BaobanPcInsertGoodsLibNoReviewRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcInsertGoodsLibNoReviewResponse>(
    prepare(baobanPcInsertGoodsLibNoReviewRequestConfig, requestData),
    ...args,
  );
};

baobanPcInsertGoodsLibNoReview.requestConfig =
  baobanPcInsertGoodsLibNoReviewRequestConfig;

export const useBaobanPcInsertGoodsLibNoReview = /*#__PURE__*/ makeRequestHook<
  BaobanPcInsertGoodsLibNoReviewRequest,
  BaobanPcInsertGoodsLibNoReviewRequestConfig,
  ReturnType<typeof baobanPcInsertGoodsLibNoReview>
>(baobanPcInsertGoodsLibNoReview);

export interface BaobanPcSaveGoodsLibNoReviewRequest {
  /**
   * goods_no
   */
  goods_no?: string;
  /**
   * 款号
   */
  goods_kh?: string;
  /**
   * 商品名
   */
  goods_name?: string;
  /**
   * 商品状态 0正常 1特价
   */
  goods_type?: string;
  /**
   * 限制上架时间 时间戳
   */
  lock_on_sale_time?: string;
  /**
   * 拿货价
   */
  market_price?: string;
  /**
   *  颜色/尺码 数组
   */
  colorSizeData?: {
    key: string;
    label: string;
    thumb: {
      name?: string;
    };
    size: {
      sku: string;
      key: string;
      label: string;
      real_stock: string;
      sale_stock: string;
      virtual_stock: string;
      supply_stock: string;
      status: boolean;
      update_stock: string;
      sku_sort: string;
      schedule_day: string;
      sku_name: string;
      in_stock_num: string;
      pre_in_stock_num: string;
    }[];
  }[];
  /**
   * 3级分类id
   */
  cat_id?: string[];
  /**
   * 活动拿货价
   */
  prefer_price?: string;
  /**
   *  商品属性 数组
   */
  prop?: {
    label: string;
    value: string;
    is_search: string;
    is_require: string;
    select_type: string;
    select: string[];
    select_new?: Array<{ size: string; value: string }>;
    list: {
      label: string;
      value: string;
      img: string;
      weight: string;
    }[];
  }[];
  /**
   * 新风格id
   */
  style_id?: string;
  /**
   * 模特图
   */
  model_img?: string[];
  /**
   * 实拍图图片
   */
  real_img?: string[];
  /**
   * 尺码图
   */
  news_img?: string;
  /**
   * 信息图图片
   */
  info_img?: string[];
  /**
   * 面料风格特色
   */
  customize_special?: string;
  /**
   * 特殊备注
   */
  customize_remark?: string;
  /**
   * 商品视频
   */
  video_url?: string;
  /**
   * 配件
   */
  parts?: string;
  /**
   * 锁库时间
   */
  lock_day: string;
}

export interface BaobanPcSaveGoodsLibNoReviewResponse {
  text?: string;
}

type BaobanPcSaveGoodsLibNoReviewRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodsLibPc/baobanPcSaveGoodsLibNoReview",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcSaveGoodsLibNoReviewRequestConfig: BaobanPcSaveGoodsLibNoReviewRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodsLibPc/baobanPcSaveGoodsLibNoReview",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      $schema: "http://json-schema.org/draft-04/schema#",
      type: "object",
      properties: {
        goods_no: { type: "string", description: "goods_no" },
        goods_kh: { type: "string", description: "款号" },
        goods_name: { type: "string", description: "商品名" },
        goods_type: { type: "string", description: "商品状态 0正常 1特价" },
        lock_on_sale_time: {
          type: "string",
          description: "限制上架时间 时间戳",
        },
        market_price: { type: "string", description: "拿货价" },
        colorSizeData: {
          type: "array",
          items: {
            type: "object",
            properties: {
              key: { type: "string" },
              label: { type: "string" },
              thumb: {
                type: "object",
                properties: { name: { type: "string" } },
              },
              size: {
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    sku: { type: "string" },
                    key: { type: "string" },
                    label: { type: "string" },
                    real_stock: { type: "string" },
                    sale_stock: { type: "string" },
                    virtual_stock: { type: "string" },
                    supply_stock: { type: "string" },
                    status: { type: "boolean" },
                    update_stock: { type: "string" },
                    sku_sort: { type: "string" },
                    schedule_day: { type: "string" },
                    sku_name: { type: "string" },
                    in_stock_num: { type: "string" },
                    pre_in_stock_num: { type: "string" },
                  },
                  required: [
                    "sku",
                    "key",
                    "label",
                    "real_stock",
                    "sale_stock",
                    "virtual_stock",
                    "supply_stock",
                    "status",
                    "update_stock",
                    "sku_sort",
                    "schedule_day",
                    "sku_name",
                    "in_stock_num",
                    "pre_in_stock_num",
                  ],
                },
              },
            },
            required: ["key", "label", "thumb", "size"],
          },
          description: " 颜色/尺码 数组",
        },
        cat_id: {
          type: "array",
          items: { type: "string" },
          description: "3级分类id",
        },
        prefer_price: { type: "string", description: "活动拿货价" },
        prop: {
          type: "array",
          items: {
            type: "object",
            properties: {
              label: { type: "string" },
              value: { type: "string" },
              is_search: { type: "string" },
              is_require: { type: "string" },
              select_type: { type: "string" },
              select: { type: "array", items: { type: "string" } },
              list: {
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    label: { type: "string" },
                    value: { type: "string" },
                    img: { type: "string" },
                    weight: { type: "string" },
                  },
                  required: ["label", "value", "img", "weight"],
                },
              },
            },
            required: [
              "label",
              "value",
              "is_search",
              "is_require",
              "select_type",
              "select",
              "list",
            ],
          },
          description: " 商品属性 数组",
        },
        style_id: { type: "string", description: "新风格id" },
        model_img: {
          type: "array",
          items: { type: "string" },
          description: "模特图",
        },
        real_img: {
          type: "array",
          items: { type: "string" },
          description: "实拍图图片",
        },
        news_img: { type: "string", tag: "4.38.0", description: "尺码图" },
        info_img: {
          type: "array",
          items: { type: "string" },
          description: "信息图图片",
          tag: "4.38.0",
        },
        customize_special: { type: "string", description: "面料风格特色" },
        customize_remark: { type: "string", description: "特殊备注" },
        video_url: { type: "string", description: "商品视频" },
        parts: { type: "string", description: "配件" },
        lock_day: { type: "string", description: "锁库时间" },
      },
      required: ["lock_day"],
    },
    responseDataJsonSchema: {
      type: "object",
      properties: { text: { type: "string" } },
    },
    requestFunctionName: "baobanPcSaveGoodsLibNoReview",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcSaveGoodsLibNoReview = /*#__PURE__*/ (
  requestData: BaobanPcSaveGoodsLibNoReviewRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcSaveGoodsLibNoReviewResponse>(
    prepare(baobanPcSaveGoodsLibNoReviewRequestConfig, requestData),
    ...args,
  );
};

baobanPcSaveGoodsLibNoReview.requestConfig =
  baobanPcSaveGoodsLibNoReviewRequestConfig;

export const useBaobanPcSaveGoodsLibNoReview = /*#__PURE__*/ makeRequestHook<
  BaobanPcSaveGoodsLibNoReviewRequest,
  BaobanPcSaveGoodsLibNoReviewRequestConfig,
  ReturnType<typeof baobanPcSaveGoodsLibNoReview>
>(baobanPcSaveGoodsLibNoReview);

export interface BaobanPcSaveMannequinRequest {
  /**
   * 模特id
   */
  model_id: string;
  /**
   * 身高
   */
  height: string;
  /**
   * 体重
   */
  weight: string;
  /**
   * 肩宽
   */
  shoulder: string;
  /**
   * 腰围
   */
  waistline: string;
  /**
   * 臀围
   */
  hipline: string;
  /**
   * 胸围
   */
  bust: string;
  /**
   * 腿长
   */
  leg: string;
  /**
   * 名称
   */
  name: string;
  /**
   * 头像
   */
  avatar: string;
}

export interface BaobanPcSaveMannequinResponse {}

type BaobanPcSaveMannequinRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/MannequinPc/baobanPcSaveMannequin",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcSaveMannequinRequestConfig: BaobanPcSaveMannequinRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/MannequinPc/baobanPcSaveMannequin",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: {
        model_id: { type: "string", description: "模特id" },
        height: { type: "string", description: "身高" },
        weight: { type: "string", description: "体重" },
        shoulder: { type: "string", description: "肩宽" },
        waistline: { type: "string", description: "腰围" },
        hipline: { type: "string", description: "臀围" },
        bust: { type: "string", description: "胸围" },
        leg: { type: "string", description: "腿长" },
        name: { type: "string", description: "名称" },
        avatar: { type: "string", description: "头像" },
      },
      required: [
        "model_id",
        "height",
        "weight",
        "shoulder",
        "waistline",
        "hipline",
        "bust",
        "name",
        "leg",
        "avatar",
      ],
    },
    responseDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: {},
    },
    requestFunctionName: "baobanPcSaveMannequin",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcSaveMannequin = /*#__PURE__*/ (
  requestData: BaobanPcSaveMannequinRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcSaveMannequinResponse>(
    prepare(baobanPcSaveMannequinRequestConfig, requestData),
    ...args,
  );
};

baobanPcSaveMannequin.requestConfig = baobanPcSaveMannequinRequestConfig;

export const useBaobanPcSaveMannequin = /*#__PURE__*/ makeRequestHook<
  BaobanPcSaveMannequinRequest,
  BaobanPcSaveMannequinRequestConfig,
  ReturnType<typeof baobanPcSaveMannequin>
>(baobanPcSaveMannequin);

export interface BaobanPcInsertNoReviewDraftRequest {
  /**
   * gfs_id
   */
  gfs_id: string;
  /**
   * 款号
   */
  goods_kh: string;
  /**
   * 模特图图片 数组
   */
  model_img: string[];
  /**
   * 实拍图图片 数组
   */
  real_img: string[];
  /**
   * 信息图图片 数组
   */
  info_img: string[];
  /**
   * 商品属性 数组
   */
  prop: string;
  /**
   * 尺码图
   */
  news_img: string[];
  size_img: string[];
  /**
   * 模特信息图
   */
  model_info_img: string;
  /**
   * 新风格id
   */
  style_id: string;
  /**
   * 商品标题
   */
  goods_name: string;
  /**
   * 拿货价
   */
  market_price: string;
  /**
   * 活动拿货价
   */
  prefer_price: string;
  /**
   * 商品品类(三级品类) 数组
   */
  cat_id: string[];
  /**
   * 限制上架时间 时间戳
   */
  lock_on_sale_time: string;
  /**
   * 商品视频
   */
  video_url: string;
  /**
   * 特价的自动下架时间
   */
  lock_day: string;
  /**
   * 商品类型 0正常 1特价
   */
  goods_type: string;
  /**
   * 颜色/尺码 数组
   */
  colorSizeData: string[];
  /**
   * 配件
   */
  parts: string;
  /**
   * 尺码信息 数组
   */
  size_chart: string;
  /**
   *  是否支持是否提前上新 1是2否
   */
  is_advance_support: string;
  /**
   * 提前上新时间 时间戳
   */
  advance_time: string;
  /**
   * 曝光给大客抢先拿时间 时间戳
   */
  customer_advance_time: string;
  /**
   * 是否支持无理由退货 1是2否
   */
  is_no_reason_support: string;
  /**
   * 面料风格特色
   */
  customize_special: string;
  /**
   * 特殊备注
   */
  customize_remark: string;
  /**
   * 是否编辑模特
   */
  try_information_picture: string;
}

export interface BaobanPcInsertNoReviewDraftResponse {}

type BaobanPcInsertNoReviewDraftRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodsLibPc/baobanPcInsertNoReviewDraft",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcInsertNoReviewDraftRequestConfig: BaobanPcInsertNoReviewDraftRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodsLibPc/baobanPcInsertNoReviewDraft",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: {
        gfs_id: { type: "string", description: "gfs_id" },
        goods_kh: { type: "string", description: "款号" },
        model_img: {
          type: "array",
          items: { type: "string" },
          description: "模特图图片 数组",
        },
        real_img: {
          type: "array",
          items: { type: "string" },
          description: "实拍图图片 数组",
        },
        info_img: {
          type: "array",
          items: { type: "string" },
          description: "信息图图片 数组",
          tag: "4.38.0",
        },
        prop: { type: "string", description: "商品属性 数组" },
        news_img: {
          type: "array",
          items: { type: "string" },
          description: "尺码图",
          tag: "4.38.0",
        },
        size_img: { type: "array", items: { type: "string" } },
        model_info_img: { type: "string", description: "模特信息图" },
        style_id: { type: "string", description: "新风格id" },
        goods_name: { type: "string", description: "商品标题" },
        market_price: { type: "string", description: "拿货价" },
        prefer_price: { type: "string", description: "活动拿货价" },
        cat_id: {
          type: "array",
          items: { type: "string" },
          description: "商品品类(三级品类) 数组",
        },
        lock_on_sale_time: {
          type: "string",
          description: "限制上架时间 时间戳",
        },
        video_url: { type: "string", description: "商品视频" },
        lock_day: { type: "string", description: "特价的自动下架时间" },
        goods_type: { type: "string", description: "商品类型 0正常 1特价" },
        colorSizeData: {
          type: "array",
          items: { type: "string" },
          description: "颜色/尺码 数组",
        },
        parts: { type: "string", description: "配件" },
        size_chart: { type: "string", description: "尺码信息 数组" },
        is_advance_support: {
          type: "string",
          description: " 是否支持是否提前上新 1是2否",
        },
        advance_time: { type: "string", description: "提前上新时间 时间戳" },
        customer_advance_time: {
          type: "string",
          description: "曝光给大客抢先拿时间 时间戳",
        },
        is_no_reason_support: {
          type: "string",
          description: "是否支持无理由退货 1是2否",
        },
        customize_special: { type: "string", description: "面料风格特色" },
        customize_remark: { type: "string", description: "特殊备注" },
      },
      required: [
        "gfs_id",
        "lock_day",
        "video_url",
        "lock_on_sale_time",
        "cat_id",
        "prefer_price",
        "market_price",
        "goods_name",
        "style_id",
        "model_info_img",
        "news_img",
        "prop",
        "info_img",
        "real_img",
        "model_img",
        "goods_kh",
        "is_advance_support",
        "size_chart",
        "parts",
        "colorSizeData",
        "goods_type",
        "customize_remark",
        "customize_special",
        "is_no_reason_support",
        "advance_time",
        "customer_advance_time",
        "size_img",
      ],
    },
    responseDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: {},
    },
    requestFunctionName: "baobanPcInsertNoReviewDraft",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcInsertNoReviewDraft = /*#__PURE__*/ (
  requestData: BaobanPcInsertNoReviewDraftRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcInsertNoReviewDraftResponse>(
    prepare(baobanPcInsertNoReviewDraftRequestConfig, requestData),
    ...args,
  );
};

baobanPcInsertNoReviewDraft.requestConfig =
  baobanPcInsertNoReviewDraftRequestConfig;

export const useBaobanPcInsertNoReviewDraft = /*#__PURE__*/ makeRequestHook<
  BaobanPcInsertNoReviewDraftRequest,
  BaobanPcInsertNoReviewDraftRequestConfig,
  ReturnType<typeof baobanPcInsertNoReviewDraft>
>(baobanPcInsertNoReviewDraft);

export interface BaobanPcCheckSkuNameListRequest {
  supply_sku: {};
  /**
   * sku 有sku就传
   */
  sku: string;
  /**
   * sku_name
   */
  sku_name: string;
}

export interface BaobanPcCheckSkuNameListResponse {}

type BaobanPcCheckSkuNameListRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodsLibPc/baobanPcCheckSkuNameList",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcCheckSkuNameListRequestConfig: BaobanPcCheckSkuNameListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodsLibPc/baobanPcCheckSkuNameList",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: {
        supply_sku: { type: "object", properties: {} },
        sku: { type: "string", description: "sku 有sku就传" },
        sku_name: { type: "string", description: "sku_name" },
      },
      required: ["supply_sku", "sku_name", "sku"],
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "baobanPcCheckSkuNameList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcCheckSkuNameList = /*#__PURE__*/ (
  requestData: BaobanPcCheckSkuNameListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcCheckSkuNameListResponse>(
    prepare(baobanPcCheckSkuNameListRequestConfig, requestData),
    ...args,
  );
};

baobanPcCheckSkuNameList.requestConfig = baobanPcCheckSkuNameListRequestConfig;

export const useBaobanPcCheckSkuNameList = /*#__PURE__*/ makeRequestHook<
  BaobanPcCheckSkuNameListRequest,
  BaobanPcCheckSkuNameListRequestConfig,
  ReturnType<typeof baobanPcCheckSkuNameList>
>(baobanPcCheckSkuNameList);

export interface BaobanPcChangeSkuStockAndStatusRequest {
  stock_list: {
    /**
     * 更新了多少库存 默认空字符串
     */
    update_stock: string;
    /**
     * 是否上架字段 1是 0否
     */
    is_sale: string;
    /**
     * sku
     */
    sku: string;
  }[];
  /**
   * 是否 断订单  1是0否
   */
  close_order: string;
}

export interface BaobanPcChangeSkuStockAndStatusResponse {}

type BaobanPcChangeSkuStockAndStatusRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodsLibPc/baobanPcChangeSkuStockAndStatus",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcChangeSkuStockAndStatusRequestConfig: BaobanPcChangeSkuStockAndStatusRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodsLibPc/baobanPcChangeSkuStockAndStatus",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: {
        stock_list: {
          type: "array",
          items: {
            type: "object",
            properties: {
              update_stock: {
                type: "string",
                description: "更新了多少库存 默认空字符串",
              },
              is_sale: { type: "string", description: "是否上架字段 1是 0否" },
              sku: { type: "string", description: "sku" },
            },
            required: ["update_stock", "is_sale", "sku"],
          },
        },
        close_order: { type: "string", description: "是否 断订单  1是0否" },
      },
      required: ["close_order", "stock_list"],
    },
    responseDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: {},
    },
    requestFunctionName: "baobanPcChangeSkuStockAndStatus",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcChangeSkuStockAndStatus = /*#__PURE__*/ (
  requestData: BaobanPcChangeSkuStockAndStatusRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcChangeSkuStockAndStatusResponse>(
    prepare(baobanPcChangeSkuStockAndStatusRequestConfig, requestData),
    ...args,
  );
};

baobanPcChangeSkuStockAndStatus.requestConfig =
  baobanPcChangeSkuStockAndStatusRequestConfig;

export const useBaobanPcChangeSkuStockAndStatus = /*#__PURE__*/ makeRequestHook<
  BaobanPcChangeSkuStockAndStatusRequest,
  BaobanPcChangeSkuStockAndStatusRequestConfig,
  ReturnType<typeof baobanPcChangeSkuStockAndStatus>
>(baobanPcChangeSkuStockAndStatus);

export interface BaobanPcGetSizeIdBySizeNameRequest {
  /**
   * 尺码 json数组
   */
  size_names: string;
}

export interface BaobanPcGetSizeIdBySizeNameResponse {
  list?: {
    label: string;
    id: string;
  }[];
}

type BaobanPcGetSizeIdBySizeNameRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodsLibPc/baobanPcGetSizeIdBySizeName",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcGetSizeIdBySizeNameRequestConfig: BaobanPcGetSizeIdBySizeNameRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodsLibPc/baobanPcGetSizeIdBySizeName",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: {
        size_names: { type: "string", description: "尺码 json数组" },
      },
      required: ["size_names"],
    },
    responseDataJsonSchema: {
      type: "object",
      properties: {
        list: {
          type: "array",
          items: {
            type: "object",
            properties: { label: { type: "string" }, id: { type: "string" } },
            required: ["label", "id"],
          },
        },
      },
    },
    requestFunctionName: "baobanPcGetSizeIdBySizeName",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcGetSizeIdBySizeName = /*#__PURE__*/ (
  requestData: BaobanPcGetSizeIdBySizeNameRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcGetSizeIdBySizeNameResponse>(
    prepare(baobanPcGetSizeIdBySizeNameRequestConfig, requestData),
    ...args,
  );
};

baobanPcGetSizeIdBySizeName.requestConfig =
  baobanPcGetSizeIdBySizeNameRequestConfig;

export const useBaobanPcGetSizeIdBySizeName = /*#__PURE__*/ makeRequestHook<
  BaobanPcGetSizeIdBySizeNameRequest,
  BaobanPcGetSizeIdBySizeNameRequestConfig,
  ReturnType<typeof baobanPcGetSizeIdBySizeName>
>(baobanPcGetSizeIdBySizeName);

export interface BaobanPcDeletePriceTimingRequest {
  /**
   * 任务id
   */
  id: string;
}

export interface BaobanPcDeletePriceTimingResponse {}

type BaobanPcDeletePriceTimingRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodsLibPc/baobanPcDeletePriceTiming",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcDeletePriceTimingRequestConfig: BaobanPcDeletePriceTimingRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodsLibPc/baobanPcDeletePriceTiming",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: "object",
      required: ["id"],
      properties: { id: { type: "string", description: "任务id" } },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "baobanPcDeletePriceTiming",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcDeletePriceTiming = /*#__PURE__*/ (
  requestData: BaobanPcDeletePriceTimingRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcDeletePriceTimingResponse>(
    prepare(baobanPcDeletePriceTimingRequestConfig, requestData),
    ...args,
  );
};

baobanPcDeletePriceTiming.requestConfig =
  baobanPcDeletePriceTimingRequestConfig;

export const useBaobanPcDeletePriceTiming = /*#__PURE__*/ makeRequestHook<
  BaobanPcDeletePriceTimingRequest,
  BaobanPcDeletePriceTimingRequestConfig,
  ReturnType<typeof baobanPcDeletePriceTiming>
>(baobanPcDeletePriceTiming);

export interface BaobanPcGetGoodsPriceTimingListRequest {
  goods_no: string;
}

export interface BaobanPcGetGoodsPriceTimingListResponse {
  list?: {
    id: string;
    /**
     * 定时时间
     */
    time: string;
    /**
     * 活动拿货价
     */
    prefer_price: string;
    /**
     * 正价拿货价
     */
    market_price: string;
    /**
     * 商品类型{0正价 1特价}
     */
    goods_type: string;
    /**
     * 锁库天数
     */
    lock_day: string;
    /**
     * 锁库时间
     */
    lock_date: string;
    /**
     * 库存信息详情 特价才有
     */
    stock_detail: {
      color: string;
      size: string;
      stock: string;
    }[];
  }[];
}

type BaobanPcGetGoodsPriceTimingListRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodsLibPc/baobanPcGetGoodsPriceTimingList",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcGetGoodsPriceTimingListRequestConfig: BaobanPcGetGoodsPriceTimingListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodsLibPc/baobanPcGetGoodsPriceTimingList",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: "object",
      required: ["goods_no"],
      properties: { goods_no: { type: "string" } },
    },
    responseDataJsonSchema: {
      type: "object",
      properties: {
        list: {
          type: "array",
          items: {
            type: "object",
            properties: {
              id: { type: "string" },
              time: { type: "string", description: "定时时间" },
              prefer_price: { type: "string", description: "活动拿货价" },
              market_price: { type: "string", description: "正价拿货价" },
              goods_type: {
                type: "string",
                description: "商品类型{0正价 1特价}",
              },
              lock_day: { type: "string", description: "锁库天数" },
              lock_date: { type: "string", description: "锁库时间" },
              stock_detail: {
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    color: { type: "string" },
                    size: { type: "string" },
                    stock: { type: "string" },
                  },
                  required: ["color", "size", "stock"],
                },
                description: "库存信息详情 特价才有",
              },
            },
            required: [
              "id",
              "time",
              "prefer_price",
              "market_price",
              "goods_type",
              "lock_day",
              "lock_date",
              "stock_detail",
            ],
          },
        },
      },
    },
    requestFunctionName: "baobanPcGetGoodsPriceTimingList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcGetGoodsPriceTimingList = /*#__PURE__*/ (
  requestData: BaobanPcGetGoodsPriceTimingListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcGetGoodsPriceTimingListResponse>(
    prepare(baobanPcGetGoodsPriceTimingListRequestConfig, requestData),
    ...args,
  );
};

baobanPcGetGoodsPriceTimingList.requestConfig =
  baobanPcGetGoodsPriceTimingListRequestConfig;

export const useBaobanPcGetGoodsPriceTimingList = /*#__PURE__*/ makeRequestHook<
  BaobanPcGetGoodsPriceTimingListRequest,
  BaobanPcGetGoodsPriceTimingListRequestConfig,
  ReturnType<typeof baobanPcGetGoodsPriceTimingList>
>(baobanPcGetGoodsPriceTimingList);

export interface BaobanPcSetGoodsPriceTimingRequest {
  _time: string;
  cat_id: string;
  stock_detail: string;
  cv: string;
  goods_no: string;
  goods_type: string;
  lock_day: string;
  market_price: string;
  sign: string;
  token: string;
  timing_date: string;
  prefer_price: string;
}

export interface BaobanPcSetGoodsPriceTimingResponse {}

type BaobanPcSetGoodsPriceTimingRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodsLibPc/baobanPcSetGoodsPriceTiming ",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcSetGoodsPriceTimingRequestConfig: BaobanPcSetGoodsPriceTimingRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodsLibPc/baobanPcSetGoodsPriceTiming ",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: "object",
      required: [
        "_time",
        "cat_id",
        "stock_detail",
        "cv",
        "goods_no",
        "goods_type",
        "lock_day",
        "market_price",
        "sign",
        "token",
        "timing_date",
        "prefer_price",
      ],
      properties: {
        _time: { type: "string" },
        cat_id: { type: "string", description: "" },
        stock_detail: { type: "string", description: "" },
        cv: { type: "string", description: "" },
        goods_no: { type: "string", description: "" },
        goods_type: { type: "string", description: "" },
        lock_day: { type: "string", description: "" },
        market_price: { type: "string", description: "" },
        sign: { type: "string", description: "" },
        token: { type: "string", description: "" },
        timing_date: { type: "string", description: "" },
        prefer_price: { type: "string", description: "" },
      },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "baobanPcSetGoodsPriceTiming",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcSetGoodsPriceTiming = /*#__PURE__*/ (
  requestData: BaobanPcSetGoodsPriceTimingRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcSetGoodsPriceTimingResponse>(
    prepare(baobanPcSetGoodsPriceTimingRequestConfig, requestData),
    ...args,
  );
};

baobanPcSetGoodsPriceTiming.requestConfig =
  baobanPcSetGoodsPriceTimingRequestConfig;

export const useBaobanPcSetGoodsPriceTiming = /*#__PURE__*/ makeRequestHook<
  BaobanPcSetGoodsPriceTimingRequest,
  BaobanPcSetGoodsPriceTimingRequestConfig,
  ReturnType<typeof baobanPcSetGoodsPriceTiming>
>(baobanPcSetGoodsPriceTiming);

/* prettier-ignore-end */
